export const calculateDiscount = (price, offerPrice) => {
  if (
    isNaN(price) ||
    isNaN(offerPrice) ||
    Number(offerPrice) >= Number(price)
  ) {
    return null;
  }
  const discount = ((price - offerPrice) / price) * 100;
  return Math.round(discount); // e.g., 23% off
};
